import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod/v4';
import { PAGE_PATHS } from '../../../../../types';
import { defaultHeadCellsBasicQuery, newDefaultDateRange } from '../../../../../views/Logs/logs.utils';
import { QueryType } from '../../../../../views/Logs/types';

const logsTabSchema = z.object({
  tabId: z.string().optional().default('-1'),
  query: z.string().optional().default(''),
  title: z.string().optional().default(''),
  lastSearch: z.coerce.date().optional(),
  queryType: z.enum(QueryType).optional().default(QueryType.Basic),
  categoryId: z.string().optional().nullable(),
  description: z.string().optional(),
  headCells: z.string().array().optional().default(defaultHeadCellsBasicQuery),
  page: z.coerce.number().optional().default(0),
  table: z.string().optional().default('LOGS'),
  __beta: z.coerce.boolean().optional().default(false),
});

export const logsSearchSchema = logsTabSchema.extend({
  date: z.tuple([z.coerce.date(), z.coerce.date()]).optional().default([newDefaultDateRange[0], newDefaultDateRange[1]]),
});

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/explore/logs/')({
  validateSearch: zodValidator(logsSearchSchema),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.LOGS });
    context.validatePermissions({ isAllowed, preload });
  },
});
